import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import AlertModal from '~/components/modals/AlertModal';
import { AlertProvider } from '~/hooks/useAlert';
import { AuthProvider } from '~/hooks/useAuth';
function RootLayout() {
    return (_jsx(AuthProvider, { children: _jsxs(AlertProvider, { children: [_jsx(AlertModal, {}), _jsx(Outlet, {})] }) }));
}
export default RootLayout;
